import { React, ReduxUtils, Consts, useSelector, useDispatch, useActiveCompanyId } from '../dependencies';

import { fetchSuppliersRequest } from '../services/actions';

const { SUPPLIERS } = Consts.entityKeys;
const { FETCH } = Consts.apiTypes;

export function useFetchSuppliers() {
    const { inProgress } = useSelector(state => ReduxUtils.apiSelector(state, SUPPLIERS, FETCH));
    const dispatch = useDispatch();
    const companyId = useActiveCompanyId();

    React.useEffect(() => {
        if (!inProgress && companyId) {
            dispatch(fetchSuppliersRequest());
        }
        // eslint-disable-next-line
    }, [companyId]);
}
